import React from 'react'

function SideHero() {
    return (
        <div className="sidehero-wrapper">
            <div className="sidehero-img"></div>
        </div>    
    );
  }

export default SideHero


// WEBPACK FOOTER //
// ./src/components/SideHero.js